<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0 d-flex flex-column gap-4" style="height: 350px">
      <!-- Header -->
      <v-container class="pa-0 ma-0 d-flex flex-column">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("products_below_min_stock") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2" style="color: #717182">
          {{ $t("products_equiring_restock") }}
        </v-card-text>
      </v-container>

      <!-- List -->
      <v-container class="pa-0 ma-0 scroll-y">
        <v-list dense class="pa-0 ma-0">
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="pa-0 my-2 ma-0"
            style="background-color: #ffe2e2ab; border-radius: 6px"
          >
            <v-list-item-content class="pa-0 ma-0 pt-4">
              <!-- Title -->
              <v-container class="pa-0 ma-0 px-2 d-flex justify-space-between">
                <v-card-text class="pa-0 ma-0 text-body-2">
                  {{ item.name }}
                </v-card-text>

                <v-card-text class="pa-0 ma-0 text-body-2">
                  <!-- {{ formatPrice(item.price) }} {{ $store.state.currency.name }} -->
                </v-card-text>
              </v-container>

              <!-- Min amount -->
              <v-container class="pa-0 ma-0 px-2 d-flex justify-space-between mt-1">
                <v-card-text class="pa-0 ma-0 text-body-2">
                  {{ $t("stock") }}
                  :{{ item.stock }}
                </v-card-text>

                <v-card-text class="pa-0 ma-0 text-body-2"
                  >{{ item.order_point }} {{ $t("min") }}
                </v-card-text>
              </v-container>

              <!-- Progress -->
              <v-progress-linear
                :value="getPercent(item.stock, item.order_point)"
                height="4"
                rounded
                color="#EF4444"
                background-color="#FADDDD"
                class="mt-2"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "LowStockItems",
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getLowStockProducts(newVal);
      },
    },
    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getLowStockProducts(newVal);
      },
    },
  },
  mounted() {
    this.getLowStockProducts();
  },
  methods: {
    getLowStockProducts(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/product-in-order-point", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data;
          app.items = res.slice(-10);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    getPercent(current, minimum) {
      if (!minimum) return 0;
      return Math.min(100, Math.round((current / minimum) * 100));
    },

    formatPrice(value) {
      return value.toLocaleString("fa-IR");
    },
  },
};
</script>

<style scoped>
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
}
.scroll-y::-webkit-scrollbar {
  display: none;
}
</style>
